import React, { useState } from 'react';
import { Home, Umbrella, Stethoscope, Scale } from 'lucide-react';

const MarketerUseCases: React.FC = () => {
  const [activeTab, setActiveTab] = useState('realestate');

  const tabs = [
    { id: 'realestate', label: 'Real Estate', icon: Home },
    { id: 'insurance', label: 'Insurance', icon: Umbrella },
    { id: 'medical', label: 'Medical', icon: Stethoscope },
    { id: 'legal', label: 'Legal', icon: Scale },
  ];

  const content: Record<string, { title: string; text: string }> = {
    realestate: {
      title: "Real Estate Coaches & Recruiters",
      text: "Find newly licensed agents in your market. Filter by brokerage to target specific firms (e.g., 'Target all agents at Keller Williams in Austin, TX who were licensed in the last 30 days'). Verify license status before your recruiting call to ensure they are still active."
    },
    insurance: {
      title: "Insurance IMOs & Lead Vendors",
      text: "Build lists of active insurance producers by state and license line (Life, Health, P&C). Know their carrier appointments before you pitch your products. Stop wasting time on agents who have surrendered their license."
    },
    medical: {
      title: "Medical & Dental Marketers",
      text: "Reach verified dentists, doctors, and specialists. Filter by practice size, specialty, and location for targeted campaigns. Ensure your list only contains licensed practitioners with active board certifications."
    },
    legal: {
      title: "Legal Marketing Agencies",
      text: "Access attorney contact data with bar status verification. Target by practice area and jurisdiction. Build authority by only reaching out to active, practicing attorneys in good standing."
    }
  };

  return (
    <section id="use-cases" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-white text-center mb-12">Who Uses ProGeoData?</h2>
        
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-6 py-3 rounded-full text-sm font-bold transition-all ${
                  activeTab === tab.id 
                    ? 'bg-sky-600 text-white shadow-lg shadow-sky-900/20' 
                    : 'bg-slate-900 text-slate-400 hover:bg-slate-800'
                }`}
              >
                <Icon className="w-4 h-4 mr-2" />
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="max-w-4xl mx-auto bg-slate-900 rounded-2xl p-8 md:p-12 border border-slate-800">
           <h3 className="text-2xl font-bold text-white mb-4">{content[activeTab].title}</h3>
           <p className="text-lg text-slate-400 leading-relaxed">{content[activeTab].text}</p>
        </div>
      </div>
    </section>
  );
};

export default MarketerUseCases;